import Http from "../../service/api";
import { judgeIsSplice } from "../../common/utils";

// -----------------------------  首页  -------------------------
/**
 * 活动集合内部用户 get query
 * @param {*} params 
 */
export async function getActivityList(params: any) {
  return Http.get(`/v1/campaign/in/list${judgeIsSplice()}`, params);
}
/**
 * 活动信息（内部用户端也可以用） get query
 * @param {*} params 
 */
export async function getActivityInfo(params: any) {
  return Http.get(`/v1/campaign/user/info${judgeIsSplice()}`, params);
}
/**
 * 活动详情（外部用户） get query
 * @param {*} params 
 */
export async function getExActInfo(params: any) {
  return Http.get(`/public/v1/campaign/ex/info`, params);
}
